export const baseUrl = 'http://localhost:8080/';
//export const baseUrl = 'https://us-central1-kauilenergyserver.cloudfunctions.net/kauilenergyServer/';
